import { render, staticRenderFns } from "./MudancaHorario.vue?vue&type=template&id=43af1438&"
import script from "./MudancaHorario.vue?vue&type=script&lang=js&"
export * from "./MudancaHorario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports